import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './containers/App/App';
import {BrowserRouter} from 'react-router-dom';

const container = document.getElementById('app');
if (!container) throw new Error('Root container missing in index.html');
const root = createRoot(container);

root.render(
	<React.Fragment>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.Fragment>
);